import React from 'react'

const ClientsSilder = () => {

  const importAll = (r) => {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  };
  
  const images = importAll(require.context('./images', false, /\.(png|jpe?g|svg|webp)$/))

  return (
    <div className='scroll-gallery'>
    {
      [...Object.keys(images), ...Object.keys(images), ...Object.keys(images)].map((imgName, index) => 
        <img alt="clients" key={`${imgName}-${index}`} src={images[imgName]} />)
    }
    </div>
  )
}

export default ClientsSilder